type OmitableNestedItem = {
  omit?: boolean;
  subItems?: OmitableNestedItem[];
  subDrawerItems?: OmitableNestedItem[];
};

type OmitableMenuItem = {
  omit?: boolean;
  subItems?: OmitableNestedItem[];
  subDrawerItems?: OmitableNestedItem[];
};

/**
 * Removes menu entries marked with `omit: true` from the top level and nested
 * `subItems` / `subDrawerItems`. Parents are kept unless they themselves are omitted.
 */
export const removeOmittedMenuItems = <T extends OmitableMenuItem>(items: T[]): T[] =>
  items
    .filter((item) => !item.omit)
    .map((item) => {
      const next = { ...item };

      if (item.subItems) {
        next.subItems = removeOmittedMenuItems(item.subItems);
      }

      if (item.subDrawerItems) {
        next.subDrawerItems = removeOmittedMenuItems(item.subDrawerItems);
      }

      return next;
    });
